module.exports = __webpack_public_path__ + "img/homePageHeader.cb90bc8a.jpg";